// ModalManageVideo.js
// @author: anghello

import React, { useCallback, useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader, TabContent, TabPane, Nav, NavItem, NavLink, Button } from 'reactstrap';
import RemixAddPhotos from '../remix/RemixAddPhotos';
import Strings from '../../translations/Translations';
import RemixManagePhotos from '../remix/RemixManagePhotos';
import RemixStyle from '../remix/RemixStyle';
import RemixPlugin from '../remix/RemixPlugin';
// import RemixApps from '../remix/RemixApps';
import StickyBox from 'react-sticky-box';
import RemixAddPhotosController from '../controllers/RemixAddPhotosController';

export default function ModalManageVideo({ open, setOpen, createMode, editMode, remixMedia, setRemixMedia, remixPars, remixStyle, parentStyle, setParentStyle, parentSelectCallback, showSaveButton }) {
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);
  const [activeTab, setActiveTab] = useState(1);
  const [currentRid, setCurrentRid] = useState();
  
  const [photosManage, setPhotosManage] = useState(true);
  const togglePhotosManage = useCallback(() => setPhotosManage(!photosManage), [photosManage, setPhotosManage]);

  useEffect(() => {
    if (remixPars && remixPars.rid) {
      setCurrentRid(remixPars.rid);
    }
  }, [remixPars]);

  useEffect(() => { if (editMode) { setActiveTab(3); } }, [editMode]);

  return (
    <Modal className='pb-modal-1' isOpen={open} toggle={toggle} size='xl'>
      <ModalHeader toggle={toggle}>
        {Strings('manage_video')}
      </ModalHeader>
      <ModalBody className='pt-0'>
        <StickyBox offsetTop={-2}>
          <Nav tabs className='mb-2 pt-2 manage-video-tabs bg-white'>
            {editMode && (
              <NavItem>
                <NavLink className={`${(activeTab === 3) ? 'active' : ''}`} onClick={() => setActiveTab(3)}>
                  {Strings('video_preview')}
                </NavLink>
              </NavItem>
            )}
            <NavItem>
              <NavLink className={`${(activeTab === 1) ? 'active' : ''}`} onClick={() => setActiveTab(1)}>
                {createMode && Strings('choose_photos')}
                {editMode && Strings('manage_photos')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={`${(activeTab === 2) ? 'active' : ''}`} onClick={() => setActiveTab(2)}>
                {createMode && <span>{Strings('choose_style')}</span>}
                {editMode && <span>{Strings('change_style')}</span>}
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink className={`${(activeTab === 4) ? 'active' : ''}`} onClick={() => setActiveTab(4)}>
                {Strings('apps')}
              </NavLink>
            </NavItem> */}
          </Nav>
        </StickyBox>
        
        <TabContent activeTab={activeTab}>
          <TabPane tabId={1} className='py-2'>
            {createMode && (
              <RemixAddPhotos remixMedia={remixMedia} setRemixMedia={setRemixMedia} pickerUploadPhoto pickerMediaPack />
            )}
            {editMode && (
              <>
                <div className='d-flex justify-content-end'>
                  <Button className='pb-btn-1' onClick={togglePhotosManage}>
                    {photosManage && Strings('add_photos')}
                    {!photosManage && Strings('manage_photos')}
                  </Button>
                </div>

                {photosManage && <RemixManagePhotos remixPars={remixPars} />}
                {!photosManage && <RemixAddPhotosController remixPars={remixPars} callback={togglePhotosManage}/>}
              </>
            )}
          </TabPane>
          <TabPane tabId={2} className='py-2'>
            <RemixStyle
              parentStyle={parentStyle}
              setParentStyle={setParentStyle}
              parentSelectCallback={(parameters) => {
                if (parentSelectCallback) { parentSelectCallback(parameters); }
              }}
              showSaveButton={showSaveButton}
              createMode={createMode}
              editMode={editMode}
              remixStyle={remixStyle}
            />
          </TabPane>
          {editMode && (
            <TabPane tabId={3} className='py-2 text-center'>
              <div className='pt-4 pb-2'>
                <RemixPlugin rid={currentRid} />
              </div>
            </TabPane>
          )}
          {/* <TabPane tabId={4} className='py-2'>
            <RemixApps />
          </TabPane> */}
        </TabContent>
      </ModalBody>
    </Modal>
  );
}
